import {getServiceTypes} from "../../repositories/adminUserRepository";
import {Autocomplete} from "./Autocomplete";

export default function ({value, setValue}) {
    const fetchItems = async () => {
        return await getServiceTypes();
    }

    return <Autocomplete
        label="Search service types"
        value={value}
        onSelect={(item) => setValue(item)}
        placeholder="Enter service type name or id..."
        fetchItems={fetchItems}
    />

    // return <AppTypeahead
    //     title="Service Type"
    //     value={value}
    //     setValue={onValueChange}
    //     fetchItems={fetchItems} />
}